import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';

import portalService from '../services/portalService';
import localStorageService from '../services/localStorageService';

import { GetSpaceContext } from '../GetSpaceContext';

const SidebarLayout = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState([]);
  
    useEffect(() => {

        const fetchUsers = async (abortController) => {
            let users = await portalService.getUsers(abortController);
            if (users && users.data) {
                setUsers(users.data);
            }
        };

        const fetchCities = async() => {
            console.log("Fetching cities");
            const cities = await portalService.getCities();
            const locs = {};
            const items = {};
            const localCities = [];
            cities.data.map((city) => {
                localCities.push({id: city.id, name: city.name});
                city.storageLocations.map((location) => {
                    locs[location.id] = location;
                    location.storageItems.map((i) => {
                        items[i.id] = i;
                    });
                });
            });
            console.log("Loaded locations", locs);

            const owners = await portalService.getOwners();
            if (owners && owners.data && owners.data.length > 0) {
                localStorageService.owners.set(owners.data);
                console.log("Setting default owner", owners.data[0].id);
                
            }
            const locks = await portalService.getLocks();
            if (locks && locks.data) {
                localStorageService.locks.set(locks.data);
            }
            
            localStorageService.cities.set(localCities);
            localStorageService.locations.set(locs);
            localStorageService.items.set(items);

            console.log("Setting default city", localCities[0].id);     
        }
        setIsLoading(true);
        
        const abortController = new AbortController();
        fetchCities().catch((reason) => {
            console.log(reason);
        }).then(() => {
            console.log("Fetched cities");
            console.log("Fetching users")
            fetchUsers(abortController)
            .finally(() => {
                console.log("Fetched users");
                setIsLoading(false);
            });
        })
        return () => abortController.abort();
    }, []);

    const component = () => {
        return (
            <div className="">
                <Sidebar />
                <div className="container-fluid p-4">
                    <Outlet />
                </div>
            </div>
        );
    }

    if (isLoading) {
        console.log("Still loading...")
        return null;
    } else {
        console.log("Loaded data");
        return <GetSpaceContext.Provider value ={users}>{component()}</GetSpaceContext.Provider>
    }
};

export default SidebarLayout;
